import { render, staticRenderFns } from "./RetainSpecimen.vue?vue&type=template&id=112bc872&scoped=true&"
import script from "./RetainSpecimen.vue?vue&type=script&lang=ts&"
export * from "./RetainSpecimen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112bc872",
  null
  
)

export default component.exports